// src/config/plux.data.ts
export interface PluxData {
  PayboxRemail: string;
  PayboxSendmail: string;
  PayboxRename: string;
  PayboxSendname: string;
  PayboxBase0: string;
  PayboxBase12: string;
  PayboxDescription: string;
  // Nombre del evento (SOLO alfanumérico) — Plux lo usa para aplicar reglas/descuentos por
  // evento configurados de su lado (ej. descuento Banco de Guayaquil). Opcional: solo se envía
  // para eventos que tengan esa condición. Nombre del campo: "PayboxEvento" (con "o" final),
  // pedido por Plux 2026-08-28 (revirtieron el "PayboxEvent" sin "o").
  PayboxEvento?: string;
  PayboxProduction: boolean;
  PayboxEnvironment: 'sandbox' | 'prod';
  PayboxLanguage: 'es';
  PayboxPagoPlux: true;
  PayboxDirection: string;
  PayBoxClientPhone: string;
  PayBoxClientIdentification: string;
  PayboxRecurrent: false;
  onAuthorize: (response: PluxResponse) => void;
  // El SDK enruta el mensaje de éxito según su forma: `status:"succeeded"` → onAuthorize;
  // `status_payment:"paid"` (el que manda Paybox en sandbox/prod) → onCatchResponse. Se
  // proveen ambos para no perder el pago (el id_transaccion viene anidado en `detail`).
  onCatchResponse?: (response: PluxCatchResponse) => void;
}

export interface PluxResponse {
  status: string; // 'succeeded' si el pago fue ok
  amount?: number;
  id_transaccion?: string;
  token?: string;
  state?: string;
  clientID?: string;
  clientName?: string;
}

export interface PluxCatchResponse {
  status_payment?: string; // 'paid' cuando el pago fue exitoso
  detail?: {
    id_transaccion?: string;
    token?: string;
    amount?: number;
    cardType?: string;
    [k: string]: unknown;
  };
  [k: string]: unknown;
}

/**
 * RF-06 — mapeo de montos: PayboxBase12 = monto CON IVA incluido,
 * PayboxBase0 = monto sin impuesto. Si el evento tiene IVA, todo el total
 * va a base12 (y base0 = 0); si no tiene IVA, todo va a base0 (y base12 = 0).
 * `total` = sale.total (monto final que paga el cliente).
 * Extraída como función pura para poder cubrirla con tests unitarios sin
 * tener que montar el checkout completo.
 */
export function splitPluxBase(
  total: number,
  iva: number,
): { base0: number; base12: number } {
  return iva > 0 ? { base12: total, base0: 0 } : { base12: 0, base0: total };
}

export function buildPluxData(p: {
  comercioEmail: string;
  comercioNombre: string;
  production: boolean;
  clienteEmail: string;
  clienteNombre: string;
  cedula: string;
  telefono: string;
  direccion: string;
  base0: number;
  base12: number;
  descripcion: string;
  payboxEvento?: string;
  onAuthorize: (r: PluxResponse) => void;
  onCatchResponse?: (r: PluxCatchResponse) => void;
}): PluxData {
  return {
    PayboxRemail: p.comercioEmail,
    PayboxSendmail: p.clienteEmail,
    PayboxRename: p.comercioNombre,
    PayboxSendname: p.clienteNombre,
    PayboxBase0: p.base0.toFixed(2),
    PayboxBase12: p.base12.toFixed(2),
    PayboxDescription: p.descripcion,
    PayboxEvento: p.payboxEvento,
    PayboxProduction: p.production,
    PayboxEnvironment: p.production ? 'prod' : 'sandbox',
    PayboxLanguage: 'es',
    PayboxPagoPlux: true,
    PayboxDirection: p.direccion || 'N/A',
    PayBoxClientPhone: p.telefono || '',
    PayBoxClientIdentification: p.cedula || '',
    PayboxRecurrent: false,
    onAuthorize: p.onAuthorize,
    onCatchResponse: p.onCatchResponse,
  };
}
